import axios from "axios";
export const state = {
    audits: [],
    audit_status: false,
};
export const getters = {
    all_audits: state => state.audits.data,
    AuditStatus: state => state.audit_status,
};

export const mutations = {
    SET_AUDITS(state, newValue) {
        state.audits = newValue;
    },
    SET_AUDIT_STATUS(state, newValue) {
        state.audit_status = newValue;
    },
};

export const actions = {
    fetchNotification({ commit, dispatch }) {
        commit('SET_AUDIT_STATUS', true)
        axios.get('audittrails').then(n_res => {
            commit('SET_AUDITS', n_res.data)
            commit('SET_AUDIT_STATUS', false)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })


    },

};